import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteTransaction from "../transactions/DeleteTransaction";



const DeleteTransactionAlert = ({ onCompletion, element, onClose, onDeleteConfirmation }) => {
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "deleteTransactionAlert" }}
        >

            <DeleteTransaction onCompletion={onCompletion} onDeleteConfirmation={onDeleteConfirmation} element={element} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteTransactionAlert;